import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'
import { defaultParams } from '@/store/common/dropdown'

export default {
  // eslint-disable-next-line consistent-return
  async getFactProvinces() {
    try {
      const response = await axios.get('categories/factProvinces/allActive')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async uploadLogo(params) {
    try {
      const response = await axios.post('uni/organizationProperties/uploadLogo', params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
